import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UsersBackendService } from 'src/app/core/services/backend/users-backend.service';
import { PortalStoreService } from 'src/app/core/store/services/portal-store.service';
import { CraftUsersSearchSelectComponent } from '../craft-users-search-select.component';

@Component({
  selector: 'craft-users-search-select-transclude',
  templateUrl: './craft-users-search-select-transclude.component.html',
  styleUrls: ['./craft-users-search-select-transclude.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CraftUsersSearchSelectTranscludeComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CraftUsersSearchSelectTranscludeComponent extends CraftUsersSearchSelectComponent {
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    portalStore: PortalStoreService,
    usersService: UsersBackendService,
  ) {
    super(changeDetectorRef, portalStore, usersService);
  }
}
